import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-quill/dist/quill.snow.css";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../Utilities/Loader';


const MemberAvailability = ({ data, selectedMember, activeMembersListData, sessionData, getActiveMembersData, getUserAvailabilityCalenderData, getSessionData, createUserAvailabilityCalenderData, getMembersListData }) => {

    const [userId, setUserId] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const project_id = data && data.project && data.project._id;
    const [userAvailabilityCalenderDataState, setUserAvailabilityCalenderDataState] = useState([]);
    const [userAvailabilityCalenderData, setUserAvailabilityCalenderData] = useState({});
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isUpdateLoading, setUpdateLoading] = useState(false);
    const [selectedMemberInfo, setSelectedMemberInfo] = useState({});
    const [weekList, setWeekList] = useState([]);
    const [selectAlldays, setAlldays] = useState(false);


    // const weekList = [
    //     {
    //         id: '1',
    //         weekNumber: 'Week1',
    //     },
    //     {
    //         id: '2',
    //         weekNumber: 'Week2',
    //     },
    //     {
    //         id: '3',
    //         weekNumber: 'Week3',
    //     },
    //     {
    //         id: '4',
    //         weekNumber: 'Week4',
    //     },
    // ];


    const onChange = (dates) => {
        setStartDate("");
        setEndDate("");
        const [start, end] = dates;
        let currentDate = start;
        let firstday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1));
        let lastday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 5))
        setStartDate(firstday);
        setEndDate(lastday);
    };

    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0 && day !== 6;
    };

    const searchAvailability = async () => {
        try {
            const user_id = userId && userId.value;
            const start_date = moment(startDate).format('YYYY-MM-DD');
            const end_date = moment(endDate).format('YYYY-MM-DD');
            if (user_id && start_date && end_date) {
                setSearchLoading(true);
                const responseData = await getUserAvailabilityCalenderData({ user_id, start_date, end_date });
                setUserAvailabilityCalenderData(responseData);
                setSearchLoading(false);
            }
            setAlldays(false);

        } catch (err) {
            setSearchLoading(false);
        }

    }

    const submitAvailability = async () => {
        try {
            const user_id = userId && userId.value;
            let avialability_calender = [];
            userAvailabilityCalenderDataState.filter(useravialbility => {
                let availabilityobject = {};
                availabilityobject.date = useravialbility.date;
                availabilityobject.availability_session = [];
                useravialbility.availability_session.filter(availabilitysession => {
                    availabilitysession.availability_session.filter(childsession => {
                        if (availabilitysession.project_id._id === project_id) {
                            if (childsession.selected) {
                                availabilityobject.availability_session.push({
                                    session_id: childsession.session_id._id
                                })
                            }

                        }


                    });
                });
                avialability_calender.push(availabilityobject);
            });

            if (user_id && project_id) {
                setUpdateLoading(true);
                const responseData = await createUserAvailabilityCalenderData({ user_id, project_id, avialability_calender });
                if (responseData.success) {
                    getMembersListData({ project_id: project_id });
                    toast.success(responseData.message);

                }
                setUpdateLoading(false);
            }

        } catch (err) {
            toast.error(err.error);
            setUpdateLoading(false);

        }

    };

    const selectAllDays = (value) => {
        let userAvaulability = userAvailabilityCalenderDataState.filter(useravialbility => {
            return useravialbility.availability_session.filter(availabilitysession => {
                return availabilitysession.availability_session.filter(childsession => {
                    childsession.selected = value;
                    return childsession;
                });
            });
        });
        setUserAvailabilityCalenderDataState(userAvaulability);
    };


    const updateSelectionStatus = (value, availind, mainind, subind) => {
        userAvailabilityCalenderDataState[availind].availability_session[mainind].availability_session[subind].selected = value;
        const updatedData = JSON.parse(JSON.stringify(userAvailabilityCalenderDataState));
        setUserAvailabilityCalenderDataState(updatedData);
    };


    const getWeekAvailability = async (item) => {
        const monday = new Date(item.mondayDate);
        const lastday = new Date(monday.setDate(monday.getDate() - monday.getDay() + 5));
        const startday = new Date(item.mondayDate);
        setStartDate(startday);
        setEndDate(lastday);
        const start_date = moment(startday).format('YYYY-MM-DD');
        const end_date = moment(lastday).format('YYYY-MM-DD');
        const responseData = await getUserAvailabilityCalenderData({ user_id: selectedMember.user_id._id, start_date, end_date });
        setUserAvailabilityCalenderData(responseData);

    }


    useEffect(() => {
        setUserAvailabilityCalenderDataState([]);
        if (data && data.project && data.project._id) {
            getActiveMembersData({ project_id: data.project._id });
            getSessionData();
        }

        let weekData = []
        let weekNumber = 1;
        let monday = moment()
            .startOf('month')
            .day("Monday");
        if (monday.date() > 7) monday.add(7, 'd');
        let month = monday.month();
        while (month === monday.month()) {
            weekData.push({
                mondayDate: monday.format("YYYY-MM-DD"),
                weekNumber: `Week${weekNumber}`,
            })
            monday.add(7, 'd');
            weekNumber++
        }
        setWeekList(weekData);

    }, [data]);


    useEffect(() => {

        if (selectedMember && selectedMember.user_id && selectedMember.user_id._id && activeMembersListData && activeMembersListData.data && activeMembersListData.data.length > 0) {
            setSelectedMemberInfo(selectedMember);
            setUserId({ label: selectedMember.user_id.email, value: selectedMember.user_id._id });
            const start = new Date();
            let currentDate = start;
            let firstday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1));
            let lastday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 5));
            setStartDate(firstday);
            setEndDate(lastday);
            if (selectedMember.user_id._id && firstday && lastday) {
                const start_date = moment(firstday).format('YYYY-MM-DD');
                const end_date = moment(lastday).format('YYYY-MM-DD');
                const getAvailabilityData = async () => {
                    const responseData = await getUserAvailabilityCalenderData({ user_id: selectedMember.user_id._id, start_date, end_date });
                    setUserAvailabilityCalenderData(responseData);
                }
                getAvailabilityData();
            }

        }


    }, [selectedMember, activeMembersListData]);



    useEffect(() =>{
        searchAvailability();
    },[userId, startDate, endDate])


    useEffect(() => {
        if (userAvailabilityCalenderData && userAvailabilityCalenderData.useravailability) {
            let userAvaulability = userAvailabilityCalenderData.useravailability.filter(useravialbility => {
                return useravialbility.availability_session.filter(availabilitysession => {
                    return availabilitysession.availability_session.filter(childsession => {
                        childsession.selected = true;
                        return childsession;
                    });
                });
            });



            let userAvaulabilityfiltered = userAvaulability.filter(useravialbility => {
                if (!useravialbility.isDatePicked && useravialbility.availability_session.length === 0) {
                    useravialbility.availability_session.push(
                        {
                            project_id: {
                                _id: project_id
                            },
                            availability_session: [
                                {
                                    selected: false,
                                    session_id: sessionData.data[0]
                                },
                                {
                                    selected: false,
                                    session_id: sessionData.data[1]
                                }
                            ]

                        }

                    )
                }

                if (useravialbility.availability_session.length === 1) {
                    if (useravialbility.availability_session[0].availability_session.length === 1) {
                        sessionData.data.filter(sessitem => {
                            if (sessitem._id !== useravialbility.availability_session[0].availability_session[0].session_id._id) {

                                useravialbility.availability_session.push(
                                    {
                                        project_id: {
                                            _id: project_id
                                        },
                                        availability_session: [{
                                            selected: false,
                                            session_id: sessitem
                                        }]
                                    });

                                if (sessitem.session_name === 'Session1') {
                                    let first = useravialbility.availability_session[0];
                                    let second = useravialbility.availability_session[1];
                                    useravialbility.availability_session = [];
                                    useravialbility.availability_session = [second, first]
                                }

                                if (useravialbility.availability_session.length === 3) {
                                    useravialbility.availability_session.pop();
                                }

                            }
                        })
                    }
                }

                return useravialbility.availability_session.filter(availabilitysession => {
                    return availabilitysession.availability_session.filter(childsession => {
                        return childsession;
                    });
                });
            });

            setUserAvailabilityCalenderDataState(userAvaulabilityfiltered);
        }

    }, [userAvailabilityCalenderData, sessionData]);


    const avaialbilitoesList = userAvailabilityCalenderDataState && userAvailabilityCalenderDataState.length > 0 && userAvailabilityCalenderDataState.map((availabilityitem, availind) => {

        let datecheck = moment().diff(moment(availabilityitem.date), 'days');

        return (
            <div className={`border-borderColor-100 border-l border-t border-b mb-2 md:mb-0 ${datecheck > 0 ? 'past-day' : ''}`}>
                <div key={availind}>
                    <div key={availind} className="grid">
                        <div className="h-full flex justify-items-center items-center border-b border-borderColor-100 relative">
                            <div className="w-full text-center py-4">
                                <span className="block text-lg font-medium text-primary">{moment(availabilityitem.date).format('DD')}</span>
                                <span className="block uppercase text-xs font-semibold text-secondary-grey-200 mb-1">{moment(availabilityitem.date).format('ddd')}</span>
                                {datecheck > 0 ? <span className="text-small  bg-secondary-blue-300 py-1 px-2.5 rounded text-primary-navyBlue absolute left-0 top-0">Past Day</span>
                                    : null}
                            </div>
                        </div>

                        <div className="h-full grid justify-items-center p-2">
                            {
                                availabilityitem.availability_session.map((availablesession, mainind) => {
                                    return availablesession.availability_session.map((sessionitem, subind) => {
                                        if (availablesession.project_id._id === project_id) {
                                            return <div key={subind} className={`flex items-center w-full justify-left bg-primary-blue-300 text-tiny font-medium my-0.5 rounded px-4 h-10 ${sessionitem.selected ? 'bg-primary-blue-400' : ''} `}>
                                                <input type="checkbox" checked={sessionitem.selected} value={sessionitem.session_id._id} onChange={(evt) => {
                                                    updateSelectionStatus(evt.target.checked, availind, mainind, subind);
                                                }} className="h-4 w-4 mr-2" />
                                                {sessionitem.session_id.session_name} </div>
                                        } else {
                                            // disable the checkbox
                                            return <div key={subind} className="inline-flex items-center w-full justify-left text-tiny font-medium my-0.5 rounded px-5 bg-greyColor-100 px-4  leading-4 h-10">

                                                <input type="checkbox" value={sessionitem.session_id._id} checked disabled className="h-4 w-4 mr-2" />
                                                <div className="text-tiny text-secondary">
                                                    {sessionitem.session_id.session_name}
                                                    <span className="block text-small">
                                                        {availablesession.project_id.name}
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    })
                                })
                            }

                        </div>
                    </div>

                </div>
            </div>

        )

    });


    return (
        <div className="w-full">
            <div>
                <div>
                    <div className="md:flex flex-wrap items-center justify-between border-b mb-4">
                        <div className="flex items-center mb-4">
                            <div className="w-16">
                                <div className="w-12 h-12 bg-secondary-blue-500 rounded-full mr-3 flex  items-center justify-center">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.68649 9.90273V9.4416V8.46963V8.30907L9.75222 8.16258C9.84675 7.95192 9.92689 7.71831 9.9885 7.46067L10.0828 7.0664L10.4452 6.93614C10.4561 6.92603 10.4971 6.88571 10.5571 6.77367C10.6466 6.60666 10.7248 6.38047 10.7981 6.12172L10.7985 6.12043C10.8889 5.80309 10.9149 5.57967 10.909 5.43474C10.9055 5.34781 10.8917 5.30828 10.8866 5.29657L10.6584 5.03142L10.7232 4.67869C10.9677 3.34623 10.8075 2.59338 10.5264 2.22079C10.3903 2.04279 10.2423 1.97663 10.1544 1.9488L9.91658 1.87348L9.77124 1.67068C9.67694 1.5391 9.47085 1.29621 9.11238 1.09869L9.10221 1.09308L9.09221 1.08716C8.71857 0.865932 8.29257 0.75 7.80201 0.75C7.71731 0.75 7.62708 0.755036 7.53117 0.761429L7.52407 0.761903L7.51696 0.762242C7.31836 0.771699 7.11764 0.80908 6.9133 0.875252C6.90457 0.878401 6.89485 0.881725 6.88421 0.885081C6.66419 0.96263 6.44134 1.07624 6.2186 1.22823L6.20929 1.23458L6.19979 1.24065C5.93443 1.41026 5.69118 1.61267 5.4819 1.83555L5.47247 1.84559L5.47238 1.8455C5.06033 2.26847 4.80971 2.72216 4.70393 3.18219L4.70119 3.19409L4.69806 3.2059C4.59428 3.59827 4.58738 3.98725 4.67242 4.36993L4.77947 4.85169L4.37939 5.14063L4.37768 5.14194C4.37624 5.14505 4.37405 5.15034 4.37156 5.15847C4.3654 5.17866 4.357 5.21793 4.35544 5.28419C4.35216 5.42327 4.37966 5.63762 4.4692 5.95617L4.46941 5.95691C4.53433 6.18875 4.60102 6.38861 4.6756 6.54586C4.71209 6.62278 4.74554 6.67884 4.77405 6.71789C4.78792 6.73689 4.79922 6.74994 4.80742 6.75843C4.81534 6.76662 4.81954 6.76972 4.81957 6.76974L5.05863 6.94337L5.11502 7.23341C5.19287 7.63378 5.32185 7.98952 5.48951 8.29822L5.58044 8.46565V8.65617V9.44488V9.906L5.16896 10.1141C4.62479 10.3894 3.06636 11.2151 1.54379 12.3997L1.5437 12.3997C1.05069 12.7832 0.75 13.3951 0.75 14.0364V14.8873C0.75 15.0869 0.913491 15.25 1.1127 15.25H14.1542C14.3506 15.25 14.5169 15.0865 14.5169 14.884V14.0331C14.5169 13.3947 14.2159 12.7797 13.7233 12.3966L9.68649 9.90273ZM9.68649 9.90273L10.098 10.1109M9.68649 9.90273L10.098 10.1109M10.098 10.1109C10.6411 10.3856 12.2 11.2147 13.7232 12.3965L10.098 10.1109ZM4.37428 5.14466L4.37436 5.14458C4.3743 5.14464 4.37427 5.14466 4.37428 5.14466ZM6.99628 0.839667C6.9956 0.840008 6.99451 0.840548 6.99333 0.841132L6.99557 0.840024L6.99628 0.839667Z" stroke="white" stroke-width="1.5"></path></svg>
                                </div>
                            </div>
                            <div className="items-center">
                                <div className="text-sm text-black font-medium text-primary block mr-5 text-sm">{selectedMemberInfo && selectedMemberInfo.user_id && selectedMemberInfo.user_id.first_name} {selectedMemberInfo && selectedMemberInfo.user_id && selectedMemberInfo.user_id.last_name}</div>
                                <span className="text-secondary-grey-200 font-medium block mr-5 text-tiny">{selectedMemberInfo && selectedMemberInfo.user_id && selectedMemberInfo.user_id.designation && selectedMemberInfo.user_id.designation.name}</span>
                            </div>
                        </div>

                        <div className="md:flex mt-5 md:mt-0 mb-4">

                            <div className="relative mb-2 md:mb-0">
                                <Select
                                    className='medium-selectbox selectbox-svg-hide appearance-none focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear text-base border rounded-md w-full placeholder-text-secondary-grey-200 text-secondary-grey-300 font-normal border-secondary-grey-400 leading-8 w-72 h-[42px]'
                                    name="client"
                                    value={userId}
                                    isSearchable={true}
                                    // defaultOptions={false}
                                    //closeMenuOnSelect={false}                        
                                    //components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                                    options={activeMembersListData && activeMembersListData.data && activeMembersListData.data.map((user) => ({ label: user.user_id.email, value: user.user_id._id }))}
                                    placeholder="Choose a Developer"
                                    classNamePrefix="dropdownSelect"
                                    onChange={(e) => {
                                        let filterddata = activeMembersListData.data.filter(item => {
                                            return (item.user_id._id === e.value)
                                        });
                                        if (filterddata.length > 0) {
                                            setSelectedMemberInfo(filterddata[0]);
                                        }
                                        setUserId(e);
                                    }}
                                />
                                <div className="absolute top-3 right-3 z-10"><svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.45028 0.686507C3.81051 0.769865 3.11031 1.03244 2.58932 1.38463C1.55569 2.08275 0.874241 3.16639 0.69919 4.38758C0.661679 4.65641 0.655427 5.25033 0.686686 5.51916C0.842982 6.77577 1.53068 7.89693 2.58932 8.61172C3.13115 8.97849 3.82718 9.23273 4.50863 9.31401C4.77746 9.34527 5.49225 9.32651 5.72982 9.28275C6.32582 9.17022 6.88432 8.9514 7.3532 8.64506L7.54909 8.51794L8.95783 9.9246C9.73306 10.6998 10.377 11.3333 10.3874 11.3333C10.4145 11.3333 11.3356 10.4122 11.3356 10.3852C11.3356 10.3747 10.7021 9.7308 9.92686 8.95557L8.52021 7.54683L8.64524 7.35094C8.96617 6.85913 9.1704 6.33606 9.28501 5.72755C9.32877 5.48998 9.34753 4.77519 9.31627 4.50636C9.16623 3.23308 8.47853 2.10567 7.41155 1.38463C6.87806 1.02411 6.1862 0.767781 5.52142 0.684423C5.31511 0.659416 4.65659 0.6615 4.45028 0.686507ZM5.28802 2.02856C5.93196 2.06816 6.66967 2.4266 7.14689 2.92674C7.69914 3.50607 7.98047 4.20419 7.98047 4.99817C7.98047 5.49207 7.89503 5.86092 7.68038 6.30063C7.35529 6.96749 6.83222 7.46139 6.1466 7.75522C5.3943 8.07615 4.48779 8.05739 3.75007 7.70521C3.48958 7.58017 3.37705 7.5114 3.15615 7.34052C2.57682 6.89247 2.17045 6.20477 2.05167 5.46706C2.01415 5.24616 2.00999 4.7877 2.04333 4.57513C2.22463 3.35812 3.12281 2.37866 4.31691 2.09108C4.52113 2.04107 4.92125 1.9973 5.04212 2.00981C5.07129 2.01398 5.18174 2.02231 5.28802 2.02856Z" fill="#54585D"></path></svg></div>
                            </div>

                            <div className="relative md:ml-2 mb-4 md:mb-0">
                                <label>
                                    <DatePicker className="text-sm custom-datepicker-wrapper placeholder-text-secondary-grey-300 relative appearance-none focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear text-base border rounded-md px-4 w-full font-normal border-secondary-grey-400 ring-transparent ring-0 w-[288px]  h-[42px]"
                                        onChange={onChange}
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange
                                        dateFormat="dd-MM-yyyy"
                                        filterDate={isWeekday}

                                    />
                                    <span className="cursor-pointer absolute right-4 top-3 z-0"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.04708 0.0437498C2.90958 0.106249 2.78771 0.231247 2.71897 0.381245C2.66272 0.503119 2.65647 0.590617 2.65647 1.25623V1.99997H2.16899C1.59714 1.99997 1.41902 2.03747 1.04716 2.2281C0.709672 2.40309 0.403435 2.70934 0.228442 3.04684C-0.0184232 3.52495 0.000326034 3.05309 0.000326034 8.99988C0.000326034 14.9467 -0.0184232 14.4748 0.228442 14.9529C0.403435 15.2904 0.709672 15.5967 1.05028 15.7748C1.51901 16.0154 0.972161 15.9998 8 15.9998C15.0278 15.9998 14.481 16.0154 14.9497 15.7748C15.2903 15.5967 15.5966 15.2904 15.7716 14.9529C16.0184 14.4748 15.9997 14.9467 15.9997 8.99988C15.9997 3.05309 16.0184 3.52495 15.7716 3.04684C15.5966 2.70934 15.2903 2.40309 14.9528 2.2281C14.581 2.03747 14.4029 1.99997 13.831 1.99997H13.3435V1.25623C13.3435 0.521869 13.3435 0.509369 13.2654 0.353121C13.2154 0.253121 13.1373 0.159373 13.056 0.106249C12.9279 0.015625 12.9248 0.015625 12.3717 0.00625038C11.7592 -0.00625038 11.678 0.0124998 11.4936 0.209373C11.3342 0.37812 11.3124 0.503119 11.3124 1.28436V1.99997H8H4.68763V1.29373C4.68763 0.521869 4.67201 0.412495 4.52514 0.234372C4.35015 0.0249996 4.25953 0 3.6658 0C3.30019 0.00312519 3.1127 0.015625 3.04708 0.0437498ZM14.6497 10.4436L14.6404 14.1717L14.5529 14.3186C14.4966 14.4154 14.4154 14.4967 14.3185 14.5529L14.1716 14.6404H8H1.82838L1.68151 14.5529C1.58464 14.4967 1.50339 14.4154 1.44714 14.3186L1.35965 14.1717L1.35027 10.4436L1.34402 6.71866H8H14.656L14.6497 10.4436Z" fill="#54585D"></path></svg></span>
                                </label>
                            </div>
                            <div className="md:ml-2">
                                <button disabled={isSearchLoading} onClick={() => { searchAvailability() }} className="flex font-title border border-primary-navyBlue bg-primary-navyBlue text-white text-sm font-semibold transition duration-300 ease-out hover:bg-opacity-80 px-4 rounded-md w-full md:w-min h-[42px] items-center">
                                    Search
                                    {isSearchLoading ? <Loader /> : null}
                                </button>
                            </div>
                        </div>
                    </div>
                    {avaialbilitoesList ?
                        <div className=" mb-4 flex flex-wrap items-center justify-between">
                            <h3 className="text-xl text-black font-medium inline-block mr-5 mb-5 sm:mb-0 md:mb-0">{userAvailabilityCalenderDataState && userAvailabilityCalenderDataState.length > 0 && startDate && moment(startDate).format('MMMM')} {userAvailabilityCalenderDataState && userAvailabilityCalenderDataState.length > 0 && startDate && moment(startDate).format('YYYY')}</h3>
                            <div>
                                {weekList.map((item, ind) =>
                                    <span onClick={() => {
                                        getWeekAvailability(item);
                                    }} key={ind} className="ml-1 md:ml-3 text-secondary-grey-300 cursor-pointer py-2 px-2 md:px-3 hover:bg-secondary-blue-600 focus:bg-secondary-blue-600 font-medium hover:text-primary-navyBlue rounded text-tiny">{item.weekNumber}</span>
                                )}
                            </div>
                        </div>
                        : " "}
                </div>
                <div className="grid md:grid-cols-5 gap-0 border-r border-borderColor-100 ">
                    {avaialbilitoesList}
                </div>
                {userAvailabilityCalenderDataState && userAvailabilityCalenderDataState.length > 0 &&
                    <span className="text-tiny items-center text-black font-medium mr-2 inline-flex content-center mt-4 mb-7">
                        <input checked={selectAlldays}  type="checkbox" onChange={(evt) => {
                            selectAllDays(evt.target.checked);
                            setAlldays(evt.target.checked);
                        }} className="h-4 w-4 mr-2" />
                        Select all days in this week</span>
                }

                {
                    userAvailabilityCalenderDataState && userAvailabilityCalenderDataState.length > 0 &&
                    <div>
                        <button disabled={isUpdateLoading} onClick={() => { submitAvailability() }} className="flex font-title border border-primary-navyBlue bg-primary-navyBlue text-white text-sm font-semibold transition duration-300 ease-out hover:bg-opacity-80 px-4 rounded-md w-full md:w-min h-12 items-center">Update
                            {isUpdateLoading ? <Loader /> : null}
                        </button>
                    </div>
                }


            </div>
        </div>
    )
}


const mapState = (state) => ({
    userAvailabilityCalenderData: state.projectDetails.userAvailabilityCalender,
    activeMembersListData: state.projectDetails.activeMembersList,
    sessionData: state.projectDetails.session
});
const mapDispatch = (dispatch) => ({
    getActiveMembersData: dispatch.projectDetails.getActiveMembersList,
    getUserAvailabilityCalenderData: dispatch.projectDetails.getUserAvailabilityCalender,
    getSessionData: dispatch.projectDetails.getSession,
    createUserAvailabilityCalenderData: dispatch.projectDetails.createUserAvailabilityCalender,
    getMembersListData: dispatch.projectDetails.getMembersList,

});

export default connect(mapState, mapDispatch)(MemberAvailability)
